import React from 'react'
import PropTypes from 'prop-types'
import ShowMore from 'react-show-more'
import styled from 'styled-components'

import MoreButton from './display/MoreButton'

const Wrapper = styled.div<{ inline?: boolean }>`
  letter-spacing: normal;

  ${({ inline }) =>
    inline &&
    `
    ${MoreButton} {
      display: inline-block;
      margin: 0;
      padding: 0;
      line-height: 1;
    }
  `}
`

const formatLineBreaks = (text: string) =>
  text &&
  text
    .trim()
    .split('\n')
    .map((line, i, arr) => {
      const span = <span key={line.slice(0, 7)}>{line}</span>

      if (i === arr.length - 1) {
        return span
      }
      return [span, <br />]
    })

type ShowMoreTextProps = {
  lines: number
  inline?: boolean
  children: string
}

const ShowMoreText = ({ lines, inline, children }: ShowMoreTextProps) => (
  <Wrapper inline={inline}>
    {/* @ts-ignore -- ShowMore types mistakenly don't allow ReactNode for `more` and `less` props */}
    <ShowMore
      lines={lines}
      less={<MoreButton>{inline ? 'Less' : '- Show Less'}</MoreButton>}
      more={<MoreButton>{inline ? 'More' : '+ Show More'}</MoreButton>}
      anchorClass="color-green"
    >
      {formatLineBreaks(children)}
    </ShowMore>
  </Wrapper>
)

ShowMoreText.propTypes = {
  children: PropTypes.string.isRequired,
  lines: PropTypes.number,
}

ShowMoreText.defaultProps = {
  lines: 3,
}

export default ShowMoreText
